import { render, staticRenderFns } from "./DialogRolePermissionComponent.vue?vue&type=template&id=1ab79db2&"
import script from "./DialogRolePermissionComponent.vue?vue&type=script&lang=js&"
export * from "./DialogRolePermissionComponent.vue?vue&type=script&lang=js&"
import style0 from "./DialogRolePermissionComponent.vue?vue&type=style&index=0&id=1ab79db2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports